export const NavigationEvent = {
  ChangeStore: 'changeStore',
  NavigateToBrandSpecial: 'navigateToBrandSpecial',
  NavigateToProduct: 'navigateToProduct',
} as const;

export type NavigationEventName =
  (typeof NavigationEvent)[keyof typeof NavigationEvent];

interface NavigationLink<Name extends NavigationEventName> {
  link: string;
  name: Name;
}

export type NavigationEventPayload =
  | NavigationLink<typeof NavigationEvent.NavigateToBrandSpecial>
  | NavigationLink<typeof NavigationEvent.NavigateToProduct>
  | { name: typeof NavigationEvent.ChangeStore };
